import { render, staticRenderFns } from "./CorporateSettings.vue?vue&type=template&id=47d096ae&scoped=true&"
import script from "./CorporateSettings.vue?vue&type=script&lang=js&"
export * from "./CorporateSettings.vue?vue&type=script&lang=js&"
import style0 from "./CorporateSettings.vue?vue&type=style&index=0&id=47d096ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d096ae",
  null
  
)

export default component.exports